import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';

export interface IPlpCategoryQuicklinksBlockComponent extends NICmsContentComponent.IData {
    categoryQuicklinks?: ICategoryQuicklinks[];
}

interface ICategoryQuicklinks {
    text: string;
    link: string;
}

@Component({
    selector: 'plp-category-quicklinks',
    templateUrl: 'plp-category-quicklinks.html',
    styleUrls: ['plp-category-quicklinks.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, HrefComponent, CarouselModule, ICmsClientModule]
})
@ICmsComponent<PlpCategoryQuicklinksBlockComponent>({
    id: 'plp-category-quicklinks-block',
    block: {
        url: 'plp-category-quicklinks-block'
    },
    onDemandOnly: true,
    name: 'Plp Category Quicklinks Block',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'categoryQuicklinks',
            title: 'Category Quicklinks',
            itemName: 'Quicklink',
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    required: true
                }
            ]
        }
    ]
})
export class PlpCategoryQuicklinksBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content!: IPlpCategoryQuicklinksBlockComponent;
}